module.exports = __webpack_public_path__ + "img/lg_ring_r_s_1_1@2x.2e7e4580.png";